import { isFeature } from 'Cloud/Application/FeaturesEs6';

/** CLOUDWEB-18010 Отображать ли загрузку файлов и папок в контекстном меню даталиста "Создать и загрузить" */
export const showUploadItemsOnDatalistContext = isFeature('show-upload-items-on-datalist-context');
